<div class="container">
    <form #changePassForm="ngForm">
        <div class="row justify-content-md-center mt-5">
            <div class="border border-primary rounded m-1 p-3 col-lg-6">
                <div class="form-group">
                    <label for="oldPass">Atual</label>
                    <input [(ngModel)]="currentPassword" required id="oldPass" type="password" name="oldPass" class="form-control" />
                </div>

                <div class="form-group">
                    <label for="newPass">Nova</label>
                    <input [(ngModel)]="newPassword" minlength="6" required id="newPass" type="password" name="newPass" class="form-control" />
                </div>

                <div class="form-group">
                    <label for="confirmPass">Confirmação</label>
                    <input [(ngModel)]="confirmPassword" required id="confirmPass" type="password" name="confirmPass" class="form-control" />
                </div>
                <button (click)="changePassword()" class="btn btn-primary float-right">Mudar</button>
                <a routerLink="/home" (click)="onCancel()" class="btn btn-secondary float-right mr-1">Cancelar</a>
            </div>
        </div>
    </form>
</div>